import { Resource } from 'src/tracker/model/tracker-model'
import { BannerResourceProperty } from '../resource-meta/banner-resource-property'

export const gemProperty = new BannerResourceProperty(
  '8332b679-2a85-42d5-b464-c288f2b74037',
  'Gems',
  'gems',
  Resource.GEMS
)
